/** Literal catalogue keys of the account page (spec §8.27), so the catalogue test sees them in the source. */
export const RIGHTS: Record<string, string> = {
  read: "account.rights.read",
  write: "account.rights.write",
  admin: "account.rights.admin",
};

export const EXPIRY: Record<string, string> = {
  "30d": "account.expiry.30d",
  "90d": "account.expiry.90d",
  "1y": "account.expiry.1y",
  never: "account.expiry.never",
};

export const REFUSED: Record<string, string> = {
  disabled: "account.refused.disabled",
  name: "account.refused.name",
  rights: "account.refused.rights",
  admin_only: "account.refused.admin_only",
  expiry: "account.refused.expiry",
  too_many: "account.refused.too_many",
  workspace: "account.refused.workspace",
};
